import { Icon, Sheet, Space, Typography } from '@sravni/react-design-system';
import { ArrowRight } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';
import type { IAnswersData, IEditorialBoardMeta } from '@sravni/types/lib/seo';
import cn from 'classnames';
import { useState } from 'react';

import { SafeHtml } from 'shared/ui/SafeHtml';

import StarLogo from './assets/star.svg';
import styles from './SeoExpertsBlock.module.scss';
import { getAvatarUrl, SeoExpertsBlockTexts } from './SeoExpertsBlock.texts';

type Props = {
  block: IEditorialBoardMeta;
};

export const SeoExpertsBlock: FC<Props> = (props) => {
  const { block, className } = props;
  const isMobile = useIsMobile();
  const [openedExpert, setOpenedExpert] = useState<number | null>(null);

  const renderToolTipContent = (item: IAnswersData) => (
    <Space className={styles.tooltip}>
      {isMobile && <Typography.Heading level={3}>{SeoExpertsBlockTexts.ToolTipTitle}</Typography.Heading>}
      <Space className={styles.expert_tooltip_block}>
        <a
          className={styles.link}
          href={`/u/${item.expertId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className={styles.expert_avatar}
            src={getAvatarUrl(item.expertId)}
          />
        </a>
        <Space
          className={styles.names}
          direction="column"
        >
          <a
            className={styles.link}
            href={`/u/${item.expertId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Typography.Text className={styles.name}>{item.name}</Typography.Text>
          </a>
          <Typography.Text className={styles.role_tp}>{item.role}</Typography.Text>
        </Space>
      </Space>
      <Space className={styles.achivments}>
        <SafeHtml html={item.description} />
      </Space>
      <Typography.Text>
        <SafeHtml html={item.text} />
      </Typography.Text>
    </Space>
  );

  return (
    <Space className={cn(styles.expert_block, className)}>
      <Space
        className={styles.title_block}
        align="center"
      >
        <StarLogo className={styles.logo} />
        <Typography.Text className={styles.title}>{SeoExpertsBlockTexts.title}</Typography.Text>
      </Space>
      {block.answersData.map((item) => (
        <Space
          key={item.expertId}
          className={styles.expert_block}
          onClick={() => setOpenedExpert(item.expertId)}
        >
          <a
            className={styles.link}
            href={`/u/${item.expertId}`}
            target="_blank"
            rel="noreferrer"
          >
            <img
              className={styles.expert_avatar}
              src={getAvatarUrl(item.expertId)}
            />
          </a>
          <Space
            className={styles.names}
            direction="column"
          >
            <a
              className={styles.link}
              href={`/u/${item.expertId}`}
              target="_blank"
              rel="noreferrer"
            >
              <Typography.Text className={styles.name}>{item.name}</Typography.Text>
            </a>
            <Typography.Text className={styles.role}>{item.role}</Typography.Text>
          </Space>
          {isMobile && (
            <Icon
              className={styles.icon}
              icon={<ArrowRight />}
            />
          )}
          {isMobile ? (
            <Sheet
              className={styles.sheet}
              visible={item.expertId === openedExpert}
              onClose={() => setOpenedExpert(null)}
            >
              {renderToolTipContent(item)}
            </Sheet>
          ) : (
            renderToolTipContent(item)
          )}
        </Space>
      ))}
    </Space>
  );
};
